import React from 'react';
export function ContactSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto text-center" data-id="element-25">
        <h2 className="text-3xl font-bold text-teal-500 mb-6 font-baloo" data-id="element-26">
          📩 CONTACT US
        </h2>
        <p className="text-lg text-gray-600 mb-8" data-id="element-27">
          Have any questions before purchasing? Need help with your download?
          <br data-id="element-28" />
          <strong data-id="element-29">We're here for you. Write to us:</strong>
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-8" data-id="element-30">
          <a href="mailto:mundoinfantildigital10@gmail.com" className="bg-teal-50 hover:bg-teal-100 border-2 border-teal-200 rounded-2xl p-6 flex items-center justify-center gap-4 transition-colors" data-id="element-31">
            <span className="text-3xl" data-id="element-32">📧</span>
            <div className="text-left" data-id="element-33">
              <p className="text-sm text-gray-500 font-bold uppercase" data-id="element-34">Email</p>
              <p className="text-teal-700 font-medium" data-id="element-35">
                mundoinfantildigital10@gmail.com
              </p>
            </div>
          </a>

          <a href="https://www.instagram.com/decomagickit/" target="_blank" rel="noopener noreferrer" className="bg-pink-50 hover:bg-pink-100 border-2 border-pink-200 rounded-2xl p-6 flex items-center justify-center gap-4 transition-colors" data-id="element-36">
            <span className="text-3xl" data-id="element-37">📸</span>
            <div className="text-left" data-id="element-38">
              <p className="text-sm text-gray-500 font-bold uppercase" data-id="element-39">
                Instagram
              </p>
              <p className="text-magenta font-medium" data-id="element-40">@decomagickit</p>
            </div>
          </a>
        </div>

        <p className="text-sm text-gray-500 italic bg-gray-50 inline-block px-6 py-2 rounded-full border border-gray-200" data-id="element-41">
          ⏰ We respond within 24 hours. Don't hesitate to reach out!
        </p>
      </div>
    </section>;
}